// External Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';


class Image extends Component {
	static srcSet;

	render() {
		this.srcSet = `${this.props.imageURL} 150w`;

		return (
			<figure className="fl-bio__image-figure">
				<img className="fl-bio__image-img" alt="profile" src={this.props.imageURL} srcSet={this.srcSet} data-parent-fit="width" />
			</figure>
		);
	}
}

Image.propTypes = {
	imageURL: PropTypes.string.isRequired,
};

export default Image;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/image.js